export const fingerprintNotValidScore = 50;
